<div class="rounded-lg border-0 mt-2">
  <div v-if="active_tab === form_name">
    <button
      class="btn btn-primary-dark btn-sm text-xxs shadow mb-3"
      data-bs-toggle="modal"
      data-bs-target="#share_credentials_modal">
      Share Credentials
    </button>
    <div class="p-4 border table-border-color rounded-lg shadow-lg">
      <div class="row">
        <!-- Verification Section -->
        <div class="col-md-12 mb-4">
          <p class="fw-bold mb-3 section-heading text-xs">Verification</p>

          <!-- Status Card -->
          <div class="card mb-3 shadow-sm border-0 rounded-3 col-md-9">
            <div class="card-body py-3 px-3">
              <!-- Header -->
              <div class="d-flex align-items-center mb-3">
                <div
                  class="rounded p-2 py-3 me-3 btn-secondary-dark d-flex align-items-center justify-content-center h-auto">
                  <i class="bi bi-person-gear fs-5"></i>
                </div>

                <div class="d-flex flex-column">
                  <span class="fw-bold text-xxs mb-1">Status</span>

                  <span class="text-muted text-xxs" v-if="!allowed_actions || allowed_actions.length === 0">
                    Please make sure all conditions in transition rules are met see details below.
                  </span>
                  <span class="text-muted text-xxs" v-else>
                    Moving from
                    <span class="fw-semibold">{{ format_question_type(status) }}</span>
                    to
                    <span class="fw-semibold">{{ format_question_type(target_status) }}</span>
                  </span>
                  <span class="d-flex align-items-center mt-1">
                    <span class="fw-bold text-xxs me-2">Conditions:</span>
                    <span v-if="allowed_actions?.[0]?.conditions_met" class="text-success d-flex align-items-center">
                      <i class="bi bi-check-circle-fill fs-6"></i>
                    </span>
                    <span v-else class="text-danger d-flex align-items-center">
                      <i class="bi bi-x-circle-fill fs-6"></i>
                    </span>
                  </span>
                </div>
              </div>

              <!-- Divider -->
              <hr class="my-2">

              <!-- Buttons -->
              <div class="d-flex justify-content-start align-items-center mt-3">
                <div v-if="is_non_entity" class="d-flex gap-2">
                  <!-- Approve Button -->
                  <button class="btn btn-sm text-xxs shadow"
                    :class="is_approve_allowed ? 'btn-primary-dark' : 'btn-secondary disabled'"
                    :disabled="!is_approve_allowed" v-if="is_moving_to_master_registered && target_status"
                    data-bs-toggle="modal" data-bs-target="#trust_number_modal"
                    @click="handle_trust_number_modal_open(target_status, 'move')"
                    :title="!is_approve_allowed ? 'Approve action is not available or conditions are not met' : 'Approve this application'">
                    Approve
                  </button>

                  <button v-else class="btn btn-sm text-xxs shadow btn-primary-dark"
                    :class="{ 'opacity-50': !is_approve_allowed || is_loading_allowed_actions }"
                    :disabled="is_loading_allowed_actions || !is_approve_allowed"
                    data-bs-toggle="modal" data-bs-target="#approval_notes_modal"
                    @click="() => { temp_approval_status = target_status; approval_notes = ''; approval_action_type = 'move'; }"
                    :title="!is_approve_allowed ? 'Approve action is not available or conditions are not met' : 'Approve this application'">
                    <span v-if="is_loading_allowed_actions" class="spinner-border spinner-border-sm me-2" role="status"
                      aria-hidden="true"></span>
                    <span v-if="is_loading_allowed_actions">Loading</span>
                    <span v-else>{{ !target_status ? 'Move Restricted' : `Move to ${format_question_type(target_status)}` }}</span>
                  </button>

                  <!-- NEW: Track History Button -->
                  <button class="btn btn-sm text-xxs shadow btn-primary-dark" data-bs-toggle="modal"
                    data-bs-target="#transition_history_modal" @click="view_transition_history"
                    title="View application transition history">
                    Track History
                  </button>

                  <!-- NEW: View Condition Details Button -->
                  <button class="btn btn-sm text-xxs shadow btn-primary-dark" data-bs-toggle="modal"
                    data-bs-target="#condition_details_modal" @click="view_condition_details"
                    title="View condition verification details">
                    Details
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Requests Section -->
        <div class="col-md-12 mb-4">
          <p class="fw-bold mb-3 section-heading text-xs">Requests</p>
          <div class="card shadow border-0">
            <div class="card-body">
              <div v-if="requests.length > 0">
                <ul class="list-unstyled mb-3">
                  <li v-for="(item, index) in requests" :key="index" class="d-flex align-items-center">
                    <i class="bi bi-clipboard-check me-2 text-green text-x"></i>
                    <span class="text-muted text-xxs">{{ item }}</span>
                  </li>
                </ul>
                <div class="text-end">
                  <button class="btn btn-secondary-dark btn-sm rounded-small text-xxs shadow text-dark"
                    @click="redirect_to_view_requests_information">View</button>
                </div>
              </div>
              <div v-else class="text-muted text-center text-xxs">No requests were made</div>
            </div>
          </div>
        </div>

        <!-- Original Trust Number Modal (UPDATED with notes field) -->
        <teleport to="body">
          <div class="modal fade" id="trust_number_modal" tabindex="-1" aria-labelledby="trust_number_modal_label"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content bg-white rounded-3">
                <div class="modal-header border-bottom-0 custom-header text-white">
                  <h5 class="modal-title text-xxs" id="trust_number_modal_label">
                    Enter Trust Number
                  </h5>
                  <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal"
                    aria-label="Close"></button>
                </div>

                <div class="modal-body py-4">
                  <div class="alert alert-info alert-dismissible fade show mb-4" role="alert">
                    <div class="d-flex align-items-center">
                      <i class="bi bi-info-circle me-2"></i>
                      <div class="text-xxs">
                        <strong>Required Information:</strong>
                        To move this application from <strong>"Submitted to Master"</strong> to <strong>"Master
                          Registered"</strong>,
                        a Trust Number is required. Please enter the Trust Number below.
                      </div>
                    </div>
                  </div>

                  <!-- Trust Number field -->
                  <div class="mb-3">
                    <label for="trustNumberInput" class="form-label text-xxs fw-bold mb-2">
                      Trust Number <span class="text-danger">*</span>
                    </label>
                    <input type="text" class="form-control form-control-sm text-xxs rounded-small p-2 shadow-sm"
                      id="trustNumberInput" v-model="trust_number_input" placeholder="Enter trust number here..."
                      @keyup.enter="handle_trust_number_submit" autofocus>
                    <small class="form-text text-muted text-xxs mt-1">
                      This number will be saved with the application record.
                    </small>
                  </div>

                  <!-- NEW: Notes Field -->
                  <div class="mb-3">
                    <label for="trustNumberNotes" class="form-label text-xxs fw-bold mb-2">
                      Notes <span class="text-danger">*</span>
                    </label>
                    <textarea class="form-control form-control-sm text-xxs rounded-small p-2 shadow-sm"
                      id="trustNumberNotes" v-model="approval_notes" rows="4"
                      :placeholder="modal_action_notes_placeholder"></textarea>
                    <small class="form-text text-muted text-xxs mt-1">
                      {{ modal_action_notes_help }}
                    </small>
                  </div>
                </div>

                <div class="modal-footer border-top-0">
                  <button type="button" class="btn btn-primary-dark btn-sm text-xxs shadow"
                    @click="handle_trust_number_submit" data-bs-dismiss="modal">
                    Submit & Approve
                  </button>
                </div>
              </div>
            </div>
          </div>
        </teleport>

        <!-- NEW: Approval Notes Modal -->
        <teleport to="body">
          <div class="modal fade" id="approval_notes_modal" tabindex="-1" aria-labelledby="approval_notes_modalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content bg-white rounded-3">
                <div class="modal-header border-bottom-0 custom-header text-white bg-primary">
                  <h5 class="modal-title text-xxs" id="approval_notes_modalLabel">
                    {{ modal_action_title }}
                  </h5>
                  <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal"
                    aria-label="Close"></button>
                </div>

                <div class="modal-body py-4">
                  <!-- Notes Field -->
                  <div class="mb-3">
                    <label for="approval_notes" class="form-label text-xxs fw-bold mb-2">
                      Notes <span class="text-danger">*</span>
                    </label>
                    <textarea class="form-control form-control-sm text-xxs rounded-small p-2 shadow-sm"
                      id="approval_notes" v-model="approval_notes" rows="4"
                      :placeholder="modal_action_notes_placeholder"></textarea>
                    <small class="form-text text-muted text-xxs mt-1">
                      {{ modal_action_notes_help }}
                    </small>
                  </div>
                </div>

                <div class="modal-footer border-top-0">
                  <button type="button" class="btn btn-primary-dark btn-sm text-xxs shadow"
                    @click="submit_verification(temp_approval_status)" data-bs-dismiss="modal"
                    :disabled="!approval_notes.trim()">
                    {{ modal_action_button_label }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </teleport>

        <teleport to="body">
          <div
            class="modal fade"
            id="share_credentials_modal"
            tabindex="-1"
            aria-labelledby="share_credentials_label"
            aria-hidden="true">

            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content bg-white rounded-3 p-0 shadow-lg">

                <div class="modal-header border-bottom-0 cute-header shadow-lg">
                  <div class="modal-title text-white">
                    <p class="text-gray-300 m-0">Share Credentials</p>
                  </div>

                  <!-- normal close -->
                  <button
                    type="button"
                    class="modal-btn-close btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close">
                  </button>
                </div>

                <div class="modal-body">
                  <div class="alert alert-info mt-3 d-flex align-items-center text-xxs">
                    <i class="fa-solid fa-info-circle me-2"></i>
                    <span>
                      We will create (or link) a user to this entity and email login credentials to the address below.
                    </span>
                  </div>

                  <div class="form-section mt-4 text-xxs">
                    <label class="fw-bold mb-1" for="share_email">Share credentials to email</label>

                    <input
                      id="share_email"
                      type="email"
                      v-model.trim="share_email"
                      class="modal-form-control form-control form-control-sm text-xxs p-2 rounded"
                      placeholder="Enter email address" />

                    <div class="d-flex justify-content-end">
                      <button
                        class="btn btn-primary-dark share-button mt-3 d-flex align-items-center text-xxs"
                        :disabled="is_sharing_credentials || !share_email"
                        @click="share_credentials">
                        <span
                          v-if="is_sharing_credentials"
                          class="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"></span>
                        <i v-else class="fa-solid fa-paper-plane me-2"></i>
                        {{ is_sharing_credentials ? 'Sharing...' : 'Share Credentials' }}
                      </button>
                    </div>

                    <!-- hidden dismiss button (data-bs driven) -->
                    <button
                      type="button"
                      ref="share_credentials_dismiss_btn"
                      class="d-none"
                      data-bs-dismiss="modal"
                      aria-label="Close">
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </teleport>



        <!-- NEW: Transition History Modal -->
        <teleport to="body">
          <div class="modal fade" id="transition_history_modal" tabindex="-1"
            aria-labelledby="transition_history_modalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header cute-header d-flex align-items-center justify-content-between px-3 py-2">
                  <h5 class="modal-title text-white text-xxs m-0" id="transition_history_modalLabel">
                    Application Transition History
                  </h5>
                  <button type="button" class="btn-close modal-btn-close" data-bs-dismiss="modal"
                    aria-label="Close"></button>
                </div>
                <div class="modal-body p-3">

                  <!-- Loading -->
                  <div v-if="loading_history" class="text-center p-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="small mb-0">Loading transition history...</p>
                  </div>
                  <div v-else-if="transition_history.length === 0" class="text-center p-4">
                    <p class="small mb-0">No transition history found for this application</p>
                  </div>

                  <!-- Timeline -->
                  <div v-else class="application-log">
                    <div class="timeline">
                      <div class="timeline-container">
                        <div class="timeline-line"></div>

                        <div v-for="(log, index) in transition_history" :key="log.id" class="timeline-item mb-2">
                          <!-- Icon -->
                          <div class="timeline-icon" :class="log.is_system_triggered ? 'error' : 'success'">
                            <i :class="log.is_system_triggered
                        ? 'fa fa-robot'
                        : 'fa fa-check'"></i>
                          </div>

                          <!-- Content -->
                          <div class="timeline-content w-200 m-0">
                            <p class="log-description small mb-1">
                              <strong>
                                {{ format_question_type(log.from_status?.name) }}
                              </strong>
                              →
                              <strong>
                                {{ format_question_type(log.to_status?.name) }}
                              </strong>
                            </p>

                            <p class="log-user small mb-0">
                              <strong>Actioned By:</strong>
                              {{ log.reviewer }} ({{ log.role }})
                            </p>

                            <p v-if="log.trust_number" class="small mb-0">
                              <strong>Trust Number:</strong> {{ log.trust_number }}
                            </p>

                            <p class="log-description small fst-italic mb-1">
                              <strong>Notes: </strong>{{ log.note || 'No notes provided' }}
                            </p>

                            <p class="log-date small mb-3">
                              <strong>Date & Time: </strong>{{ format_date(log.date_created) }}
                            </p>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </teleport>

        <!-- Condition Details Modal -->
        <teleport to="body">
          <div class="modal fade" id="condition_details_modal" tabindex="-1"
            aria-labelledby="condition_details_modalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
              <div class="modal-content bg-white rounded-3">
                <div class="modal-header border-bottom-0 custom-header text-white bg-info">
                  <h5 class="modal-title text-xxs" id="condition_details_modalLabel">
                    Condition Verification Details
                  </h5>
                  <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal"
                    aria-label="Close"></button>
                </div>

                <div class="modal-body py-4">
                  <!-- Header Info -->
                  <div class="alert alert-info mb-4" role="alert">
                    <div class="d-flex align-items-center">
                      <i class="bi bi-info-circle me-2"></i>
                      <div class="text-xxs">
                        <template v-if="allowed_actions && allowed_actions.length > 0">
                          <strong>Overview:</strong>
                          Showing verification details for conditions required to move from
                          <strong>{{ format_question_type(status) }}</strong> to <strong>{{ format_question_type(target_status || '—') }}</strong>
                        </template>
                        <template v-else>
                          <strong>Overview:</strong>
                          No allowed actions available. Checking what conditions are not met for the current status.
                        </template>
                      </div>
                    </div>
                  </div>

                  <!-- Conditions Summary -->
                  <div class="mb-4">
                    <template v-if="current_condition_details">
                      <div class="d-flex align-items-center justify-content-between mb-3">
                        <span class="badge" :class="current_condition_details.all_met ? 'bg-success' : 'bg-danger'">
                          {{ current_condition_details.all_met ? 'All Conditions Met' : 'Conditions Not Met' }}
                        </span>
                      </div>

                      <div
                        v-if="current_condition_details.conditions && current_condition_details.conditions.length > 0">
                        <div v-for="(condition, index) in current_condition_details.conditions" :key="index"
                          class="card mb-3 border-0 shadow-sm">
                          <div class="card-body">
                            <!-- Condition Header -->
                            <div class="d-flex align-items-center justify-content-between mb-2">
                              <div class="d-flex align-items-center">
                                <div>
                                  <h6 class="text-xxs fw-bold mb-0">
                                    Condition {{ index + 1 }}: {{ condition.condition_type }}
                                  </h6>
                                </div>
                              </div>
                            </div>

                            <!-- Condition Details -->
                            <div v-if="condition.data" class="mt-3">
                              <!-- For Section Completion -->
                              <div v-if="condition.condition_type === 'section_completion'">
                                <div v-if="condition.completion_type === 'verified'">
                                  <div class="table-responsive">
                                    <table class="table table-hover w-100 table-fixed">
                                      <thead class="custom-header">
                                        <tr>
                                          <th
                                            class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start col-50">
                                            Section Name</th>
                                          <th
                                            class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start col-50">
                                            Verification Status</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="section in condition.data.sections" :key="section.section_id">
                                          <td class="text-xxs text-dark text-start col-50">
                                            <!-- Find section name from form tree data -->
                                            <template v-if="form_data && form_data.length > 0">
                                              <span v-for="tab in form_data" :key="tab.id">
                                                <span v-for="sec in tab.sections" :key="sec.id">
                                                  <span v-if="sec.section_id === section.section_id">
                                                    {{ sec.section_name || 'Unknown Section' }}
                                                  </span>
                                                </span>
                                              </span>
                                            </template>
                                            <template v-else>
                                              {{ section.section_id }}
                                            </template>
                                          </td>
                                          <td class="text-xxs text-dark text-start col-50">
                                            <span class="text-dark">
                                              <i
                                                :class="section.is_verified ? 'bi bi-check-circle-fill text-success' : 'bi bi-x-circle-fill text-danger'"></i>
                                              {{ section.is_verified ? 'Verified' : 'Not Verified' }}
                                            </span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                                <div v-else>
                                  <div class="table-responsive">
                                    <table class="table table-hover w-100 table-fixed">
                                      <thead class="custom-header">
                                        <tr>
                                          <th
                                            class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start col-16">
                                            Question</th>
                                          <th
                                            class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start col-16">
                                            Section Name</th>
                                          <th
                                            class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start col-16">
                                            Mandatory</th>
                                          <th
                                            class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start col-16">
                                            Answer</th>
                                          <th
                                            class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start col-16">
                                            Verified</th>
                                          <th
                                            class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start col-16">
                                            Status</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="question in condition.data.questions" :key="question.question_id">
                                          <td class="text-xxs text-dark text-start col-16">{{ question.question_text }}
                                          </td>
                                          <td class="text-xxs text-dark text-start col-16">
                                            <!-- Find section name from form tree data -->
                                            <template v-if="form_data && form_data.length > 0">
                                              <span v-for="tab in form_data" :key="tab.id">
                                                <span v-for="sec in tab.sections" :key="sec.id">
                                                  <span v-if="sec.section_id === question.section_id">
                                                    {{ sec.section_name || 'Unknown Section' }}
                                                  </span>
                                                </span>
                                              </span>
                                            </template>
                                            <template v-else>
                                              {{ question.section_id }}
                                            </template>
                                          </td>
                                          <td class="text-xxs text-dark text-start col-16">
                                            <span class="text-dark">
                                              {{ question.is_mandatory ? 'Yes' : 'No' }}
                                            </span>
                                          </td>
                                          <td class="text-xxs text-dark text-start col-16">
                                            <span class="text-dark">
                                              {{ question.latest_answer?.answer || 'No Answer' }}
                                            </span>
                                          </td>
                                          <td class="text-xxs text-dark text-start col-16">
                                            <span class="text-dark">
                                              {{ question.is_verified ? 'Yes' : 'No' }}
                                            </span>
                                          </td>
                                          <td class="text-xxs text-dark text-start col-16">
                                            <span class="text-dark">
                                              {{ question.is_complete ? 'Complete' : 'Incomplete' }}
                                            </span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>

                              <!-- For Question Completion -->
                              <div v-if="condition.condition_type === 'question_completion'">
                                <div v-if="condition.completion_type === 'verified'">
                                  <div class="table-responsive">
                                    <table class="table table-hover w-100 table-fixed">
                                      <thead class="custom-header">
                                        <tr>
                                          <th
                                            class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start col-50">
                                            Question Text</th>
                                          <th
                                            class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start col-50">
                                            Verification Status</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="question in condition.data.questions" :key="question.question_id">
                                          <td class="text-xxs text-dark text-start col-50">
                                            <!-- Find question text from form tree data -->
                                            <template v-if="form_data && form_data.length > 0">
                                              <span v-for="tab in form_data" :key="tab.id">
                                                <span v-for="sec in tab.sections" :key="sec.id">
                                                  <span v-for="q in sec.questions" :key="q.id">
                                                    <span v-if="q.question_id === question.question_id">
                                                      {{ q.question_text || 'Unknown Question' }}
                                                    </span>
                                                  </span>
                                                </span>
                                              </span>
                                            </template>
                                            <template v-else>
                                              {{ question.question_id }}
                                            </template>
                                          </td>
                                          <td class="text-xxs text-dark text-start col-50">
                                            <span class="text-dark">
                                              <i
                                                :class="question.is_verified ? 'bi bi-check-circle-fill text-success' : 'bi bi-x-circle-fill text-danger'"></i>
                                              {{ question.is_verified ? 'Verified' : 'Not Verified' }}
                                            </span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                                <div v-else>
                                  <div class="table-responsive">
                                    <table class="table table-hover w-100 table-fixed">
                                      <thead class="custom-header">
                                        <tr>
                                          <th
                                            class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start col-20">
                                            Question Text</th>
                                          <th
                                            class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start col-20">
                                            Answer</th>
                                          <th
                                            class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start col-20">
                                            Approved</th>
                                          <th
                                            class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start col-20">
                                            Verified</th>
                                          <th
                                            class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start col-20">
                                            Status</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="question in condition.data.questions" :key="question.question_id">
                                          <td class="text-xxs text-dark text-start col-20">{{ question.question_text ||
                                            'Unknown Question' }}</td>
                                          <td class="text-xxs text-dark text-start col-20">
                                            <span class="text-dark">
                                              {{ question.latest_answer?.answer || 'No Answer' }}
                                            </span>
                                          </td>
                                          <td class="text-xxs text-dark text-start col-20">
                                            <span class="text-dark">
                                              {{ question.is_approved ? 'Yes' : 'No' }}
                                            </span>
                                          </td>
                                          <td class="text-xxs text-dark text-start col-20">
                                            <span class="text-dark">
                                              {{ question.is_verified ? 'Yes' : 'No' }}
                                            </span>
                                          </td>
                                          <td class="text-xxs text-dark text-start col-20">
                                            <span class="text-dark">
                                              {{ question.is_complete ? 'Complete' : 'Incomplete' }}
                                            </span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>

                              <!-- Summary -->
                              <div class="alert"
                                :class="condition.data.all_complete || condition.data.all_verified ? 'alert-success' : 'alert-danger'"
                                role="alert">
                                <div class="d-flex align-items-center">
                                  <i
                                    :class="condition.data.all_complete || condition.data.all_verified ? 'bi bi-check-circle' : 'bi bi-x-circle'"></i>
                                  <div class="ms-2">
                                    <strong>
                                      {{ condition.condition_type === 'section_completion' ? 'Section' : 'Question' }}
                                      {{ condition.completion_type === 'verified' ? 'Verification' : 'Completion' }}
                                    </strong>
                                    <div class="text-xxs">
                                      {{ condition.data.all_complete || condition.data.all_verified ? 'All items meet the requirements' : 'Some items do not meet the requirements' }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else-if="current_condition_details.message" class="text-center text-muted py-4">
                        <i class="bi bi-info-circle fs-4 mb-3"></i>
                        <p class="text-xxs mb-0">{{ current_condition_details.message }}</p>
                      </div>
                      <div v-else class="text-center text-muted py-4">
                        <i class="bi bi-info-circle fs-4 mb-3"></i>
                        <p class="text-xxs mb-0">No condition details available.</p>
                        <p class="text-xxs mb-0">Either no conditions are required or details are not available.</p>
                      </div>
                    </template>
                    <template v-else>
                      <div class="text-center text-muted py-4">
                        <div class="spinner-border text-primary" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <p class="text-xxs mb-0 mt-2">Loading condition details...</p>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </teleport>
        <!-- Status Override -->
        <div class="col-md-12">
          <p class="fw-bold mb-3 section-heading text-xs">Status Override</p>
          <div class="card shadow border-0">
            <div class="card-body">
              <p class="text-muted text-xxs">Override the current status of the application.</p>
              <div class="d-flex gap-2">
                <select v-model="selected_status"
                  class="form-select form-select-sm text-xxs rounded-small p-2 shadow-sm">
                  <option value="" disabled selected>Select Status</option>
                  <option v-for="status in filtered_status_list" :key="status.id" :value="status.raw_status">
                    {{ status.human_readable_status }}
                  </option>
                </select>
                <button v-if="selected_status && is_moving_to_master_registered"
                  class="btn btn-primary-dark btn-sm text-xxs shadow" data-bs-toggle="modal"
                  data-bs-target="#trust_number_modal" @click="handle_trust_number_modal_open(selected_status, 'override')">
                  Override Status
                </button>

                <button v-else class="btn btn-primary-dark btn-sm text-xxs shadow" data-bs-toggle="modal"
                  data-bs-target="#approval_notes_modal"
                  @click="() => { temp_approval_status = selected_status; approval_notes = ''; approval_action_type = 'override'; }"
                  :disabled="!selected_status">
                  Override Status
                </button>
              </div>
              <small class="text-danger text-xxs" v-if="override_error">Please select a status first</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>